import { useStaticQuery, Link, graphql } from 'gatsby';

import * as styles from './Footer.module.scss';

import { ReactComponent as Logo } from '../../assets/svg/logo.svg';

import MarkdownContent from '../MarkdownContent';

export default function Footer() {
	const copyrightDate = new Date().getFullYear();
	const {
		site,
		description,
		legalPage,
		i18NJson: i18n,
	} = useStaticQuery(graphql`
		query {
			site {
				siteMetadata {
					title
				}
			}
			i18NJson {
				ui {
					homeBack
					about
					portfolio
					testimonials
					blog
					contact
				}
			}
			description: mdx(
				fields: {
					collection: { eq: "pages" }
					page: { eq: "footer" }
					block: { eq: "description" }
				}
			) {
				body
			}
			legalPage: mdx(
				fields: {
					collection: { eq: "pages" }
					page: { eq: "legal" }
					block: { eq: null }
				}
			) {
				frontmatter {
					title
				}
			}
		}
	`);

	return (
		<footer className={styles.footer}>
			<div className={styles.footerWrapper}>
				<div className={styles.brandCol}>
					<div className={styles.brand}>
						<Link
							to={'/'}
							title={i18n.ui.homeBack}
							className={styles.brandLink}
						>
							<span className="sr-only">
								{site.siteMetadata.title}
							</span>
							<Logo className={styles.logo} />
						</Link>
					</div>
					<div className={styles.brandDescription}>
						<MarkdownContent>{description.body}</MarkdownContent>
					</div>
				</div>
				<div className={styles.contactCol}>
					<div className={styles.brandContact}>
						<header>
							<h2>Grenoble</h2>
						</header>
						<div className={styles.brandContactContent}>
							<p>
								<a
									href="http://maps.google.com/?q=ELEARNIS"
									rel="noopener noreferrer"
									className="address"
								>
									8 chemin du Pré Carré 38240 Meylan - FRANCE
								</a>
							</p>
							<p>
								<a
									href="tel:+33458003868"
									className="telephone"
								>
									+33 (0)4 58 00 38 68
								</a>
							</p>
							<p>
								<a
									href="mail&#116;o&#58;&#99;&#111;&#110;&#116;&#97;&#99;&#116;&#64;&#101;&#108;&#101;&#97;&#114;&#110;&#105;&#115;&#46;&#102;&#114;"
									className="email"
								>
									&#99;&#111;&#110;&#116;&#97;&#99;&#116;&#64;&#101;&#108;&#101;&#97;&#114;&#110;&#105;&#115;&#46;&#102;&#114;
								</a>
							</p>
						</div>
					</div>
				</div>
				<div className={styles.navCol}>
					<nav className={styles.nav}>
						<header>
							<h2>Navigation</h2>
						</header>
						<ul>
							<li>
								<Link
									to={
										process.env.GATSBY_PAGES_LEGAL_SLUG ||
										'/legal/'
									}
								>
									{legalPage.frontmatter.title}
								</Link>
							</li>
							<li>
								<Link
									to={
										process.env.GATSBY_PAGES_ABOUT_SLUG ||
										'/about/'
									}
								>
									{i18n.ui.about}
								</Link>
							</li>
							<li>
								<Link
									to={
										process.env
											.GATSBY_PAGES_PORTFOLIO_SLUG ||
										'/portfolio/'
									}
								>
									{i18n.ui.portfolio}
								</Link>
							</li>
							<li>
								<Link
									to={
										process.env
											.GATSBY_PAGES_TESTIMONIALS_SLUG ||
										'/testimonials/'
									}
								>
									{i18n.ui.testimonials}
								</Link>
							</li>
							<li>
								<Link
									to={
										process.env.GATSBY_PAGES_BLOG_SLUG ||
										'/blog/'
									}
								>
									{i18n.ui.blog}
								</Link>
							</li>
							<li>
								<Link
									className={styles.contact}
									to={
										process.env.GATSBY_PAGES_CONTACT_SLUG ||
										'/contact/'
									}
								>
									{i18n.ui.contact}
								</Link>
							</li>
						</ul>
					</nav>
				</div>
			</div>
			<div className={styles.afterFooter}>
				<p className={styles.copyright}>
					&copy; 2011-{copyrightDate} {site.siteMetadata.title}. Tous
					droits réservés.
				</p>
				<p className={styles.social}>
					<a
						href="http://maps.google.com/?q=ELEARNIS"
						rel="noopener noreferrer"
						className="btn btn-lg"
					>
						<i className="fa fa-map-marker"></i>
						<span className="sr-only">google maps</span>
					</a>
					<a
						href="https://www.linkedin.com/company/2376894"
						rel="noopener noreferrer"
						className="btn btn-lg"
					>
						<i className="fa fa-linkedin"></i>
						<span className="sr-only">linkedin</span>
					</a>
					<a
						href="https://twitter.com/elearnis"
						rel="noopener noreferrer"
						className="btn btn-lg"
					>
						<i className="fa fa-twitter"></i>
						<span className="sr-only">twitter</span>
					</a>
				</p>
			</div>
		</footer>
	);
}
